// extracted by mini-css-extract-plugin
export default {"review":"review_review__vRgmN","text":"review_text__zlc2K"};